<template>
  <v-container>
    <div class="block pa-2 galleryBlock">
      <h2 class="text-center">Галерия</h2>
      <v-row>
        <v-col
          v-for="item in items"
          :key="item.id"
          class="d-flex child-flex"
          cols="6"
          sm="4"
        >
          <v-img :src="item.src" aspect-ratio="1" class="grey lighten-2">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Header",

  data() {
    return {
      items: [
        {
          id: 1,
          src: require("../assets/images/01galr.jpg"),
        },
        {
          id: 2,
          src: require("../assets/images/02galr.jpg"),
        },
        {
          id: 3,
          src: require("../assets/images/03galr.png"),
        },
        {
          id: 4,
          src: require("../assets/images/04galr.png"),
        },
        {
          id: 5,
          src: require("../assets/images/05galr.jpg"),
        },
        {
          id: 6,
          src: require("../assets/images/06galr.png"),
        },
        {
          id: 7,
          src: require("../assets/images/07galr.jpg"),
        },
        {
          id: 8,
          src: require("../assets/images/08galr.jpg"),
        },
        {
          id: 9,
          src: require("../assets/images/09galr.jpg"),
        },
      ],
    };
  },
};
</script>
